import React from 'react';
import ReactDOM from 'react-dom';
import AuthState from './context/AuthContext';
import StatesState from './context/StatesContext';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthState>
        <StatesState>
          <App />
        </StatesState>
      </AuthState>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);
